import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type TenantSkillAutocompleteSerializerType = {
  query: string;
  limit: number;
  strict: boolean;
};

export const apiFetchTenantSkillAutocomplete = async ({
  payload,
  domain = useTenantStore().domain,
  errorConfig = {},
  callbacks = {},
  signal = null,
}: PostRequestArgsType<TenantSkillAutocompleteSerializerType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.tenantSkillAutocomplete({ domain }),
      payload,
      signal,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
